var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8148 4.59476L16.8152 4.59506L23.7751 9.63246C23.7751 9.63249 23.7752 9.63252 23.7752 9.63256C24.3192 10.0265 24.8442 10.6811 25.234 11.4535C25.6235 12.2252 25.8454 13.05 25.8454 13.75V22.225C25.8454 25.0225 23.6561 27.25 21.0129 27.25H7.98704C5.34584 27.25 3.15454 25.0121 3.15454 22.2125V13.5875C3.15454 12.9384 3.35522 12.1554 3.71008 11.4098C4.06514 10.6638 4.54349 10.0205 5.03843 9.62118L5.03859 9.62105L11.0903 4.73521C11.0906 4.73494 11.0909 4.73467 11.0913 4.73441C12.653 3.48343 15.1922 3.41868 16.8148 4.59476ZM14.5 24.6875C15.4334 24.6875 16.1562 23.9025 16.1562 23V19.25C16.1562 18.3475 15.4334 17.5625 14.5 17.5625C13.5666 17.5625 12.8437 18.3475 12.8437 19.25V23C12.8437 23.9025 13.5666 24.6875 14.5 24.6875Z",
    stroke: "#4A061B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b39bdc5bac7308f8cdafa541aa7ba0e1.svg";
export { ForwardRef as ReactComponent };